import {ChangeDetectorRef, Component, Inject, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subject} from 'rxjs';
import {select, Store} from '@ngrx/store';
import {AppState} from '../../../../core/ngrx';
import {Router} from '@angular/router';
import {AuthService} from '../../../../core/ngrx/main/auth.service';
import {DEMO_PARAMS} from '../../../../core/configapp/config';
import {AuthModel} from '../../../../core/models/main/auth.model';
import {DemandeSession} from '../../../../core/ngrx/main/session/session.actions';
import {selectSessionReponse} from '../../../../core/ngrx/main/session/session.reducer';
import {ReponseModel} from '../../../../core/models/reponse.model';

@Component({
  selector: 'kt-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss']
})
export class LoginModalComponent implements OnInit {

	// Public params
	loginForm: FormGroup;
	loading = false;

	msgErrors: string = '';

	private unsubscribe: Subject<any>;


	// Constructor
	constructor(
		private dialogRef: MatDialogRef<LoginModalComponent>,
				@Inject(MAT_DIALOG_DATA) public data: any,
		private store: Store<AppState>,
		private router: Router,
		private authService: AuthService,
		private fb: FormBuilder,
		private cdr: ChangeDetectorRef,
	) {
		this.unsubscribe = new Subject();
	}


	/**
	 * On init
	 */
	ngOnInit(): void {
		this.initLoginForm();
	}

	/**
	 * On destroy
	 */
	ngOnDestroy(): void {
		this.unsubscribe.next();
		this.unsubscribe.complete();
		this.loading = false;
	}

	/**
	 * Form initalization
	 * Default params, validators
	 */
	initLoginForm() {
		// demo message to show
		this.loginForm = this.fb.group({
			email: [DEMO_PARAMS.EMAIL, Validators.required],
			password: [DEMO_PARAMS.PASSWORD, Validators.required]
		});
	}

	//Se connecter
	seconnecter() {
		const controls = this.loginForm.controls;
		/** check form */
		if (this.loginForm.invalid) {
			Object.keys(controls).forEach(controlName =>
				controls[controlName].markAsTouched()
			);
			return;
		}

		this.loading = true;
		this.authService.login(controls.email.value, controls.password.value).subscribe(
			(_data: AuthModel) => {
				if (_data) {
					if (_data.id) {
						this.authService.enregistrerLoginEnLocal(_data);
						// Charger les permissions
						this.store.dispatch(new DemandeSession(_data.id));
						this.store.pipe(select(selectSessionReponse)).subscribe(
							(reponse: ReponseModel) => {
								if (reponse.isRequestOk) {
									this.loading = false;
									this.cdr.detectChanges();
									if (!reponse.isErreur) {
										this.dialogRef.close(true);
									}
								}
							}
						);
					}else{
						this.loading = false;
						this.cdr.detectChanges();
					}
				}
			}
		);
	}


	//quitter l'app
	quitter(){
		this.authService.logout();
		this.dialogRef.close(true);
	}

}
